(() => {
  const renderGuarantee = () => {
    document.querySelectorAll('.nadelya-page').forEach((page) => {
      const buttonRow = page.querySelector('.nadelya-home-hero .nadelya-btn-row');
      const source = page.querySelector('.nadelya-feature-grid .nadelya-feature-item:nth-child(3)');
      if (!buttonRow || !source) return;

      const title = source.querySelector('strong')?.textContent?.trim() || '';
      const detail = source.querySelector('span:not(.nadelya-icon-circle)')?.textContent?.trim() || '';
      const text = [title, detail].filter(Boolean).join(' — ');
      if (!text) return;

      let line = buttonRow.parentElement.querySelector(':scope > .nadelya-hero-guarantee');
      if (!line) {
        line = document.createElement('div');
        line.className = 'nadelya-hero-guarantee';
        line.innerHTML = '<span class="nadelya-hero-guarantee__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"></circle><path d="m8.5 12 2.2 2.2 4.8-5"></path></svg></span><span class="nadelya-hero-guarantee__text"></span>';
        buttonRow.insertAdjacentElement('afterend', line);
      }

      const textNode = line.querySelector('.nadelya-hero-guarantee__text');
      if (textNode) textNode.textContent = text;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderGuarantee, { once: true });
  } else {
    renderGuarantee();
  }

  document.addEventListener('shopify:section:load', renderGuarantee);
  document.addEventListener('shopify:section:select', renderGuarantee);
  document.addEventListener('shopify:section:reorder', renderGuarantee);
})();